<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('category.label')" :columns="6">
        <select v-model="filters.category" class="form-select" @change="fillProductTypes">
          <option :value=null>Todas</option>
          <option v-for="category in categories" :value="category.name" :key="category.name">{{ category.name }}</option>
        </select>
      </form-group>

      <form-group :label="$t('productType.label')" :columns="6" v-if="productTypes.length">
        <select v-model="filters.productType" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="productType in productTypes" :value="productType.id" :key="productType.name">{{ productType.name }}</option>
        </select>
      </form-group>

      <form-group label="Tipo de preço" :columns="6">
        <select v-model="filters.price.type" class="form-select">
          <option :value=null>Todos</option>
          <option value="source">Preço Módulo</option>
          <option value="custom">Customizado</option>
          <option value="percent">Percentual sobre preço de venda</option>
          <option value="fixed">Valor fixo sobre preço de venda</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      categories: [],
      productTypes: [],
      filters: {
        brand: null,
        category: null,
        productType: null,
        price: {
          type: null
        }
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))

      api.getCategories(this.module.type, this.module.identifier)
        .then(categories => { this.categories = categories })
        .catch(() => (this.categories = []))
    },
    methods: {
      fillProductTypes () {
        if (!this.filters.category) {
          this.productTypes = []
          return
        }

        this.productTypes = this.categories
          .find(category => category.name === this.filters.category)
          .productTypes
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Amazon.vue?7b1cb768